import { render, staticRenderFns } from "./items_autocomplete.vue?vue&type=template&id=6b87ee58"
import script from "./items_autocomplete.vue?vue&type=script&lang=js"
export * from "./items_autocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports